import React from 'react';

import 'video.js/dist/video-js.css';
import '@videojs/themes/dist/fantasy/index.css';
import '../../../helpers/clipVideoPlayer.css';

import HLSPlayer from '../../../helpers/HLSPlayer';
import { HitScopeVideoLoading } from './HitScopeVideoLoading';
import { HitScopeClip } from '../hitScope.types';

interface HitScopeVideoPlayerProps {
  clips: HitScopeClip[];
  m3u8Text: string | undefined;
  onClipChanged: (clip: HitScopeClip) => void;
  seekToClip: HitScopeClip | undefined;
}

const HitScopeVideoPlayer: React.FC<HitScopeVideoPlayerProps> = ({
  clips,
  m3u8Text,
  onClipChanged,
  seekToClip,
}) => {
  return (
    <>
      {m3u8Text && clips ? (
        <HLSPlayer
          m3u8Text={m3u8Text}
          clips={clips}
          style={{ width: '100%', maxWidth: '100%' }}
          onClipChanged={onClipChanged}
          seekToClip={seekToClip}
        />
      ) : (
        <HitScopeVideoLoading />
      )}
    </>
  );
};

export default HitScopeVideoPlayer;
